import { render } from "./frontpage.vue?vue&type=template&id=2ba83cd9&scoped=true"
import script from "./frontpage.vue?vue&type=script&lang=js"
export * from "./frontpage.vue?vue&type=script&lang=js"

import "./frontpage.vue?vue&type=style&index=0&id=2ba83cd9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba83cd9"]])

export default __exports__